import React from "react";
import "./Footer.scss";
import { Button } from "@netapp/bxp-design-system-react";
import { useTranslation } from "react-i18next";

// Get the current year
const currentYear = new Date().getFullYear();

const Footer = () => {
  const { t } = useTranslation();

  const footerLinks = [
    { text: `©${currentYear} NetApp, Inc.`, url: null },
    {
      text: t("termsOfUse.other"),
      url: "https://www.netapp.com/company/legal/terms-of-use/",
    },
    {
      text: t("privacyPolicy.other"),
      url: "https://www.netapp.com/company/legal/privacy-policy/",
    },
    {
      text: t("cookieSettings.other"),
      url: null,
      id: "tcm-sdk-show-settings",
      isSpecial: true,
    },
  ];

  const feedbackLink = {
    text: t("sendFeedback.other"),
    url: "https://listening.netapp.com/jfe/form/SV_dcilAAaRGF9r95A",
  };

  return (
    <footer className="footerFrame" role="contentinfo" aria-label="Site footer">
      <div className="utilities">
        <div className="utilities-left">
          {footerLinks.map((link, index) => (
            <Button
              key={index}
              variant="text"
              className="footer-links"
              onClick={() => {
                if (link.url) {
                  window.location.href = link.url;
                }
                // Cookie Settings click is handled by cookieSettings.js when id is present
              }}
              {...(link.id && { id: link.id })}
            >
              {link.text}
            </Button>
          ))}
        </div>

        <div className="utilities-right">
          <Button
            variant="text"
            className="footer-links"
            onClick={() => {
              if (feedbackLink.url) {
                window.location.href = feedbackLink.url;
              }
            }}
          >
            {feedbackLink.text}
          </Button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;